import { GET_CHAT_REQUESTED, GET_CHAT_SUCCESS, GET_CHAT_FAILURE } from './chat.constants'
import API from './chat.api'

export const getChat = ccrId => {
  return async dispatch => {
    dispatch(getChatRequested())
    try {
      const data = await API.getChat(ccrId)
      dispatch(getChatSuccess(data))
    } catch (error) {
      dispatch(getChatFailure(error))
    }
  }
}

export const getChatRequested = () => ({
  type: GET_CHAT_REQUESTED,
})

export const getChatSuccess = data => ({
  type: GET_CHAT_SUCCESS,
  data,
})

export const getChatFailure = error => ({
  type: GET_CHAT_FAILURE,
  error,
})
